import { useLoginWhoAmI } from "@crowdcoursing/api/openapi";
import { Navigate } from "react-router-dom";

import { type ParticipantInfo } from "~hooks/useAIChat";
import { useAITutorPreferences } from "~hooks/useAITutorPreferences";
import { Route } from "~services/router/Route";
import { hasAITutorAccess } from "~utils/roleUtils";

import { type RoleConstants } from "../../../state/userSlice";
import { AIChat } from "../../organisms/AIChat";
import { AIChatTemplate } from "../../templates/AIChatTemplate";

export const AIChatPage = () => {
  const { data: userProfile } = useLoginWhoAmI({});
  const { preferences } = useAITutorPreferences();

  const userId = userProfile?.userDto?.id;
  const roles = (userProfile?.userDto?.roles || []) as RoleConstants[];

  if (!userId) {
    return (
      <AIChatTemplate>
        <div>Loading...</div>
      </AIChatTemplate>
    );
  }

  // Check if user has required role access
  if (!hasAITutorAccess(roles)) {
    return <Navigate to={Route.home()} replace />;
  }

  // Use preferences for participant info
  const participantInfo: ParticipantInfo = {
    gradeLevel: preferences.gradeLevel,
    subject: preferences.subject,
  };

  return (
    <AIChatTemplate>
      <AIChat userId={userId} participantInfo={participantInfo} />
    </AIChatTemplate>
  );
};
